import { useTheme } from '@emotion/react';
import 'react';
import { IconBadge } from '../visual-elements/IconBadge/index.js';
import { ICONS_INFO, DEFAULT_ICON_INFO } from './utils.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FileIcon = ({
  extension
}) => {
  const theme = useTheme();
  const getIconInfo = () => {
    const iconInfo = ICONS_INFO({
      theme
    }).find(({
      extensions
    }) => extensions.includes(extension.toLowerCase()));
    return iconInfo || DEFAULT_ICON_INFO({
      theme
    });
  };
  const {
    color,
    icon
  } = getIconInfo();
  return jsx(IconBadge, {
    backgroundColor: color,
    size: "lg",
    icon: icon
  });
};

export { FileIcon };
